import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next'; // AJOUT
import '../../CSS/Visiter.css';
import BeninInfo from "../composant_reutilisable/BeninInfo";
import Carousel from "../composant_reutilisable/Carousel";
import Africa from '../../images/Africa.svg';
import pr from '../../images/pr.png';
import { FaArrowRight } from "react-icons/fa";
import { useLanguageData } from '../../hooks/useLanguageData'; // Remplacer useApiProxy
import SafeHTML from "../SafeHTML";

const Visiter = () => {
    const { t } = useTranslation(); // AJOUT: Hook de traduction
    
    // Hook pour les liens utiles (tourisme)
    const { 
        data: linksResponse, 
        loading: linksLoading, 
        error: linksError 
    } = useLanguageData('/api/v1/embassy/useful-links-category?slugCategory=lien-site');

    // Hook pour les données du président (premier)
    const { 
        data: presidentResponse1, 
        loading: presidentLoading1, 
        error: presidentError1 
    } = useLanguageData('/api/v1/embassy/static-data?slug=president_benin_un');

    // Hook pour les données du président (deuxième)
    const { 
        data: presidentResponse2, 
        loading: presidentLoading2, 
        error: presidentError2 
    } = useLanguageData('/api/v1/embassy/static-data?slug=president_benin_deu');

    // États pour les données
    const [linksData, setLinksData] = useState([]);
    const [presidentData1, setPresidentData1] = useState(null);
    const [presidentData2, setPresidentData2] = useState(null);

    // Traiter les données des liens utiles
    useEffect(() => {
        if (linksResponse?.data && Array.isArray(linksResponse.data)) {
            // console.log('📊 Données API liens utiles (tourisme):', linksResponse);
            setLinksData(linksResponse.data);
        }
    }, [linksResponse]);

    // Traiter les données du président 1
    useEffect(() => {
        if (presidentResponse1?.data && presidentResponse1.data.length > 0) {
            // console.log('📊 Données président 1:', presidentResponse1);
            setPresidentData1(presidentResponse1.data[0]);
        }
    }, [presidentResponse1]);

    // Traiter les données du président 2
    useEffect(() => {
        if (presidentResponse2?.data && presidentResponse2.data.length > 0) {
            // console.log('📊 Données président 2:', presidentResponse2);
            setPresidentData2(presidentResponse2.data[0]);
        }
    }, [presidentResponse2]);

    const loading = linksLoading || presidentLoading1 || presidentLoading2;

    // Trouver les données pour chaque slug
    const tourismeData = linksData.find(item => item.slug === 'visiter_tourisme_details');
    const secondButtonData = linksData.find(item => item.slug === 'visiter_tourisme_details_un');

    // Données du président
    const quoteText = presidentData1?.content?.replace(/<\/?p>/g, '') || "";
    const quoteSource = presidentData1?.name || "";
    const presidentName = presidentData2?.content?.replace(/<\/?p>/g, '') || "";
    const presidentTitle = presidentData2?.name || "";
    const presidentImage = presidentData1?.image || "";

    // Composant Contenu non disponible
    const ContenuNonDisponible = () => (
        <div style={{
            color: '#999',
            fontSize: '14px',
            fontStyle: 'italic',
            padding: '10px 0',
            textAlign: 'center',
            width: '100%'
        }}>
            {t('common.infoUnavailable')}
        </div>
    );

    return (
        <div className="visiter-container mt-4">
            <div className="visiter-content">
                <div className="visiter-texte">
                    <div className="visiter-paragraphe">
                        {loading ? (
                            <div className="loading-container">
                                <div className="loading-spinner"></div>
                                <p>{t('common.loading')}</p>
                            </div>
                        ) : (
                            <>
                                <h1 className="tourisme-title">
                                    {tourismeData?.name || t('visiter.defaultTitle')}
                                </h1>

                                {/* Affichage du contenu HTML depuis le backend */}
                                <div className="tourisme-content">
                                    {tourismeData?.description ? (
                                        <SafeHTML html={tourismeData.description} />
                                    ) : (
                                        <ContenuNonDisponible />
                                    )}
                                </div>

                                {/* BOUTONS AVEC DONNÉES DYNAMIQUES */}
                                <div className="buttons-container">
                                    {tourismeData?.textBouton && tourismeData?.linkAccess ? (
                                        <a className="btn-invest" href={tourismeData.linkAccess} target="_blank" rel="noopener noreferrer">
                                            {tourismeData.textBouton}
                                            <FaArrowRight className="btn-icon" />
                                        </a>
                                    ) : (
                                        <div style={{ marginRight: "15px" }}>
                                            <ContenuNonDisponible />
                                        </div>
                                    )}
                                    
                                    {/* {secondButtonData?.textBouton && secondButtonData?.linkAccess ? (
                                        <a className="btn-secondary" href={secondButtonData.linkAccess} target="_blank" rel="noopener noreferrer">
                                            {secondButtonData.textBouton}
                                        </a>
                                    ) : (
                                        <div>
                                            <ContenuNonDisponible />
                                        </div>
                                    )} */}
                                </div>
                            </>
                        )}
                    </div>

                    {/* Image - seulement affichée si disponible */}
                    {!loading && tourismeData?.imageBanner && (
                        <div className="visiter-img">
                            <img
                                src={tourismeData.imageBanner}
                                alt={tourismeData.name || t('visiter.tourismAlt')}
                                onError={(e) => {
                                    console.warn('Image non chargée');
                                    e.target.style.display = 'none';
                                }}
                            />
                        </div>
                    )}
                </div>

                <BeninInfo />

                {/* BLOC PR AVEC GESTION D'ERREUR */}
                <div className="presidential-block">
                    {loading ? (
                        <div className="loading-container">
                            <div className="loading-spinner"></div>
                            <p>{t('common.loading')}</p>
                        </div>
                    ) : (
                        <div className="presidential-content">
                            <div className="presidential-text">
                                {quoteText ? (
                                    <span className="quote">
                                        {quoteText}
                                    </span>
                                ) : (
                                    <ContenuNonDisponible />
                                )}
                                
                                {quoteSource ? (
                                    <span className="quote-source">
                                        {quoteSource}
                                    </span>
                                ) : (
                                    <ContenuNonDisponible />
                                )}
                                
                                {presidentName ? (
                                    <span className="president-name">
                                        {presidentName}
                                    </span>
                                ) : (
                                    <ContenuNonDisponible />
                                )}
                                
                                {presidentTitle ? (
                                    <span className="president-title">
                                        {presidentTitle}
                                    </span>
                                ) : (
                                    <ContenuNonDisponible />
                                )}
                            </div>
                            <div>
                                {presidentImage ? (
                                    <img src={presidentImage} className="president-image" alt={t('visiter.presidentAlt')} />
                                ) : (
                                    <ContenuNonDisponible />
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Styles pour le chargement */}
            <style jsx>{`
                .loading-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 2rem;
                    text-align: center;
                    min-height: 200px;
                    width: 100%;
                }

                .loading-spinner {
                    width: 40px;
                    height: 40px;
                    border: 4px solid #f3f3f3;
                    border-top: 4px solid #1a3c5e;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin-bottom: 1rem;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                .tourisme-content {
                    line-height: 1.6;
                    text-align: left;
                }

                .tourisme-content p {
                    margin-bottom: 1.5rem;
                    text-align: left;
                }

                .tourisme-content span {
                    color: #000;
                }

                /* Styles spécifiques pour le bloc présidentiel */
                .presidential-block {
                    margin-top: 3rem;
                }

                .presidential-block .loading-container {
                    min-height: 150px;
                    padding: 1.5rem;
                }

                .presidential-block .loading-spinner {
                    width: 30px;
                    height: 30px;
                    margin-bottom: 0.5rem;
                }
            `}</style>
        </div>
    );
};

export default Visiter;